module.exports = __webpack_public_path__ + "static/media/1.0c9fd239.png";